var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-order-status",attrs:{"title":_vm.datetime}},[_c('text-string',_vm._b({},'text-string',_vm.textStringLabelIdProps,false)),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.formattedTime))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }